import { OutbreakScope } from "../Shared/ruleset.constants";

// Tie-break between tripped rules with the same number of cases: the wider scope wins.
const SCOPE_PRIORITY = Object.freeze({
  [OutbreakScope.Unit]: 1,
  [OutbreakScope.Facility]: 2,
});

const scopePriority = (alert) => SCOPE_PRIORITY[alert.threshold.scope] || 0;

// The tripped alert whose outbreak record would link the most cases. With the seeded rules a
// Facility rule's matchingCases is a superset of the Unit rule's, so Facility wins; when a tenant
// tunes the Facility window shorter (or its shared-symptom bar higher) the Unit rule can see more
// cases and then it wins instead, so no case the rules found is left unlinked. Equal counts fall
// back to the wider scope.
const linksMoreCases = (candidate, best) => {
  const byCount = candidate.matchingCases.length - best.matchingCases.length;
  if (byCount !== 0) return byCount > 0;
  return scopePriority(candidate) > scopePriority(best);
};

// Picks the one alert the prompt flow acts on from the API's `outbreakAlerts` list.
// Link mode first: the open-outbreak lookup is per facility + site, so every alert carries the
// same value and any one of them will do. Otherwise the tripped alert that links the most cases.
// Returns null when there is nothing to prompt for (empty list, or nothing tripped and no open
// outbreak), which callers treat as "no prompt".
export const selectAlertToAct = (alerts) => {
  if (!Array.isArray(alerts) || alerts.length === 0) return null;
  const withOpenOutbreak = alerts.find((alert) => !!alert.openOutbreak);
  if (withOpenOutbreak) return withOpenOutbreak;
  const tripped = alerts.filter((alert) => alert.criteriaMet === true);
  if (tripped.length === 0) return null;
  return tripped.reduce((best, alert) => (linksMoreCases(alert, best) ? alert : best));
};
